/**
 * @generated SignedSource<<eec5b01e3ab0ef056daf784ca68164b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InspectionfieldStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "OPEN" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MapListViewFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly externalId: number | null;
      readonly field: {
        readonly geometry: any | null;
      } | null;
      readonly id: string;
      readonly latestInspection: {
        readonly approvedDate: any | null;
        readonly lastModified: any | null;
        readonly rejectedDate: any | null;
        readonly retryDate: any | null;
      } | null;
      readonly periodEnd: any | null;
      readonly periodStart: any | null;
      readonly plannedDate: any | null;
      readonly state: InspectionfieldStateEnum | null;
      readonly year: number;
      readonly " $fragmentSpreads": FragmentRefs<"InspectionFieldCard">;
    } | null;
  } | null>;
  readonly totalCount: number | null;
  readonly " $fragmentType": "MapListViewFragment";
};
export type MapListViewFragment$key = {
  readonly " $data"?: MapListViewFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MapListViewFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapListViewFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionfieldNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InspectionfieldNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "year",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodStart",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodEnd",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "InspectionNode",
              "kind": "LinkedField",
              "name": "latestInspection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastModified",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "approvedDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "retryDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rejectedDate",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FieldNode",
              "kind": "LinkedField",
              "name": "field",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "geometry",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "InspectionFieldCard"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "InspectionfieldNodeConnection",
  "abstractKey": null
};

(node as any).hash = "3723d046f43ff68506c3944f6406d8d2";

export default node;
